var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.logs.length === 0
      ? _c("div", [_vm._v(" 暂无数据 ")])
      : _c(
          "div",
          [
            _c(
              "el-timeline",
              { attrs: { reverse: _vm.reverse } },
              _vm._l(_vm.logs, function (activity, index) {
                return _c(
                  "el-timeline-item",
                  { key: index, attrs: { timestamp: activity.soperaTime } },
                  [
                    activity.btype === 1
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":创建"))])
                      : activity.btype === 2
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":修改"))])
                      : activity.btype === 3
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":出货"))])
                      : activity.btype === 4
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":改单"))])
                      : activity.btype === 5
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":取消"))])
                      : activity.btype === 6
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":退回"))])
                      : activity.btype === 7
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":核销"))])
                      : activity.btype === 8
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":删除"))])
                      : activity.btype === 9
                      ? _c("span", [
                          _vm._v(_vm._s(activity.sopera + ":到店无货")),
                        ])
                      : activity.btype === 10
                      ? _c("span", [_vm._v(_vm._s(activity.sopera + ":下架"))])
                      : _c("span", [
                          _vm._v(_vm._s(activity.sopera + ":未知操作")),
                        ]),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }